<ngx-ui-loader [fgsType]="spinner_type" [fgsSize]="60" [fgsColor]="fgsColor" [hasProgressBar]=false></ngx-ui-loader>
<router-outlet></router-outlet>